import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Booking, Country, Telephone } from 'models';
import { take } from 'rxjs/operators';
import { AddressService } from 'services';

@Component({
	selector: 'app-telephone-picker',
	template: require('./telephone-picker.component.html'),
	viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class TelephonePickerComponent implements OnInit {
	@Input() required: boolean = true;
	@Input() telephone: Telephone;

	@Output() notify: EventEmitter<{ guestTelephone: string; telephone: Telephone }> = new EventEmitter();

	popularCountries: Country[];
	otherCountries: Country[];
	booking: Booking = new Booking();

	selectedPhoneCode: string;
	phoneNumber: string;

	phoneNumberMinLengthRequired = false;

	constructor(private addressService: AddressService) {}

	public ngOnInit(): void {
		this.addressService
			.getCountries()
			.pipe(take(1))
			.subscribe(countries => {
				this.popularCountries = countries.filter(country => country.name === 'United Kingdom' || country.name === 'United States');
				this.otherCountries = countries.filter(country => country.name !== 'United Kingdom' && country.name !== 'United States');
			});

		if (this.telephone) {
			this.selectedPhoneCode = this.telephone.code;
			this.phoneNumber = this.telephone.number;
		}
	}

	// remove leading 0, whitespaces, and non-numeric-characters from telephone
	concatenatePhoneNumber(): void {
		if (this.phoneNumber) {
			let fullNumber = this.phoneNumber;
			let trimNumber = fullNumber
				.replace(/^0+|\s+/g, '')
				.replace(/\D/g, '')
				.toString()
				.trim();
			this.phoneNumber = trimNumber;
		}
	}

	validateNumber(): void {
		this.phoneNumberMinLengthRequired = this.phoneNumber && this.phoneNumber.length < 7;
	}

	sendPhoneNumber(): void {
		if (this.selectedPhoneCode && this.phoneNumber && this.phoneNumber.length > 6) {
			this.booking.guestTelephone = this.selectedPhoneCode + this.phoneNumber;
			this.notify.emit({
				guestTelephone: this.booking.guestTelephone,
				telephone: {
					code: this.selectedPhoneCode,
					number: this.phoneNumber,
				},
			});
		}
	}
}
